import React from 'react';
import { Stack, useLocalSearchParams } from 'expo-router';
import SignInScreen from '@/components/domain/auth/SignInScreen';
import { CommunityCode, isCommunityCode } from '@/constants/communities';
import { NotFoundContent } from '@/components/ui/NotFoundContent';
import { useTranslation } from 'react-i18next';
import { isAppLinkRedirectMode } from '@/components/providers/AppLinkProvider';
import { useRawSearchParam } from '@/hooks/useRawSearchParam';

const getSingleParam = (value: string | string[] | undefined): string | undefined => {
  return Array.isArray(value) ? value[0] : value;
};

export default function CommunitiesSignIn() {
  const { community, redirectMode } = useLocalSearchParams<{
    community?: CommunityCode | string[];
    redirectMode?: string | string[];
  }>();
  const redirect = useRawSearchParam('redirect');
  const communityParam = getSingleParam(community);
  const communityCode = isCommunityCode(communityParam) ? communityParam : undefined;
  const redirectModeParam = getSingleParam(redirectMode);
  const appLinkRedirectMode = isAppLinkRedirectMode(redirectModeParam) ? redirectModeParam : undefined;
  const { t } = useTranslation();

  return (
    <>
      <Stack.Screen options={{ title: t('auth.signIn.title') }} />
      {communityCode ? (
        <SignInScreen
          community={communityCode}
          title={t('auth.signIn.title')}
          redirect={redirect}
          redirectMode={appLinkRedirectMode}
        />
      ) : (
        <NotFoundContent />
      )}
    </>
  );
}


